// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3F43d","errors":"Errors_errors__1ieDz"};